
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living/programme",
      function () {
        return require("private-next-pages/living/programme.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living/programme"])
      });
    }
  